// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropbox[data-v-1ad9a5d0]{outline:2px dashed grey;outline-offset:-10px;background:#e0ffff;color:#696969;padding:10px 10px;min-height:200px;position:relative;cursor:pointer}.input-file[data-v-1ad9a5d0]{opacity:0;width:100%;height:200px;position:absolute;cursor:pointer}.dropbox[data-v-1ad9a5d0]:hover{background:#add8e6}.dropbox p[data-v-1ad9a5d0]{font-size:1.2em;text-align:center;padding:50px 0}", ""]);
// Exports
module.exports = exports;
